 /* jshint esversion: 6 */
 const state = {
  msg: {
    number: 0, // websocket重连次数
    count: 0, // header.vue中count
    list: [],
    show: false,
    content: {},
  },
};

export default state;
